import * as Yup from 'yup';

export const TERRAIN_INFO_KEYS = [
  {
    key: 'difficulty_level',
    title: 'Difficulty Level',
  },
  {
    key: 'total_length',
    title: 'Total Length',
    subtitle: 'in kilometers',
  },
  {
    key: 'highest_altitude',
    title: 'Highest Altitude',
    subtitle: 'in meters',
  },
  {
    key: 'elevation_profile',
    title: 'Elevation Profile',
  },
  {
    key: 'start_location',
    title: 'Start location',
  },
  {
    key: 'finish_location',
    title: 'Finish location',
  },
  {
    key: 'permits',
    title: 'Permits',
  },
  {
    key: 'best_seasons',
    title: 'Best Season',
  },
  // {
  //   key: 'best_season',
  //   title: 'Best Season',
  // },
  // {
  //   key: 'total_climb',
  //   title: 'Total Climb',
  // },
  // {
  //   key: 'average_walking_hrs',
  //   title: 'Average Walking Hrs.',
  // },
  // {
  //   key: 'has_domestic_air_travel',
  //   title: 'Has Domestic Air',
  // },
];

const schema = {
  start_date: Yup.date().required('Required'),
  price: Yup.number()
    .required('Required')
    .min('1', 'Too Low!'),
  min: Yup.number()
    .required('Required')
    .integer('Invalid!')
    .min('1', 'Too Low!'),
  max: Yup.number()
    .required('Required')
    .integer('Invalid!')
    .test('match', 'Cannot be less than minimum!', function(max) {
      return !(max < this.options.parent.min);
    })
    .test('match', 'Cannot be same!', function(max) {
      return !(max === this.options.parent.min);
    }),
};

export const ForkGuidedSchema = Yup.object().shape({
  ...schema,
});

export const ForkSelfGuidedSchema = Yup.object().shape({
  start_date: schema.start_date,
});

export const PriceEditorSchema = Yup.object().shape({
  price: schema.price,
});

export const BasicInfoEditorSchema = Yup.object().shape({
  min: schema.min,
  max: schema.max,
});



// WEBPACK FOOTER //
// ./src/components/TrekDetail/constants.js